export default "__VITE_ASSET__CK05qYqb__"